import { render, staticRenderFns } from "./removeKeywords.vue?vue&type=template&id=d2711b88&scoped=true&"
import script from "./removeKeywords.vue?vue&type=script&lang=js&"
export * from "./removeKeywords.vue?vue&type=script&lang=js&"
import style0 from "./removeKeywords.vue?vue&type=style&index=0&id=d2711b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2711b88",
  null
  
)

export default component.exports